// 品牌文案与 favicon 配置同时供浏览器代码和 Node 构建脚本使用。
const COMPANY_SETTINGS_CONTENT_MAP = {
  global: {
    title: "APEXMOVE",
    slogan: "WATCH YOU WANT!",
    copyright: "Copyright © 2026 Hongkong Amazwear Tech CO., LTD. ",
    favicon: "logo-apexmove.png",
  },
  hk: {
    title: "APEXMOVE",
    slogan: "WATCH YOU WANT!",
    copyright: "Copyright © 2026 Hongkong Amazwear Tech CO., LTD. ",
    favicon: "logo-apexmove.png",
  },
  cn: {
    title: "猎动",
    slogan: "您的健康与健身伴侣",
    copyright: "Copyright © 2026 猎动科技",
    favicon: "logo-liedong.png",
  },
  cm: {
    title: "Carbinox MAX",
    slogan: "DURABILITY AND RELIABILITY, BEYOND REALITY!",
    copyright: "Copyright © 2026 OHMIUX LLC",
    favicon: "logo-carbinox.png",
  },
  rm: {
    title: "Ryze Move",
    slogan: "DURABILITY AND RELIABILITY, BEYOND REALITY!",
    copyright: "Copyright © 2026 Directed Electronics Australia Pty. Ltd.",
    favicon: "logo-ryzemove.png",
  },
};

module.exports = { COMPANY_SETTINGS_CONTENT_MAP };
